module.exports = __webpack_public_path__ + "media/images/brand/logo-circular-half-b497315413d8ae4791636fc51cff5a9a.svg";